import { fillString } from '@local_modules/generic/string-template.js'
import { callApi } from '@local_modules/generic/fetch.js'

/**
 * filterDates
 *  journalDates=[from,to]
 *
 * @param {*} context
 * @param {String} context.showOrgId
 * @returns
 */
export async function loadDataJournals (context) {
  console.log('loadDataJournals', context)
  let urlQuery = 'journalDates=:journalsFrom,:journalsTo&recordingDates=:recordingFrom,:recordingTo'

  urlQuery = fillString(urlQuery, {
    journalsFrom: context.filterDates?.journals?.from || 'notSet',
    journalsTo: context.filterDates?.journals?.to || 'notSet'
  })
  urlQuery = fillString(urlQuery, {
    recordingFrom: context.filterDates?.records?.from || 'notSet',
    recordingTo: context.filterDates?.records?.to || 'notSet'
  })

  const accountingOrganisationId = context.showOrgId

  const apiEndpoint = '/api/ledger/org/:accountingOrganisationId/journals-entries'
  const apiEndpointFilled = fillString(apiEndpoint, { accountingOrganisationId })
  const loadedData = await callApi(`${apiEndpointFilled}?${urlQuery}`)
  return loadedData
}
